<dx-radio-group #dx
    [dataSource]="dataSource()"
    [itemTemplate]="itemTemplate()? 'itemTemplate' : 'item'"
    [valueExpr]="valueExpr()"
    [displayExpr]="displayExpr()"
    [value]="value()"
    (onBlur)="onTouched()"
    (onValueChanged)="onValueChanged($event)">

    <div *dxTemplate="let data of 'itemTemplate'">
        <ng-template [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
    </div>
</dx-radio-group>
